module.exports = __webpack_public_path__ + "img/strikethrough.48d620ce.svg";